import { useScroll } from 'framer-motion';
import { useMemo, useEffect, useCallback } from 'react';

import { useBoolean } from 'src/hooks/use-boolean';

type ReturnType = boolean;

interface UseScrollOptions extends Omit<ScrollOptions, 'container' | 'target'> {
  container?: React.RefObject<HTMLElement>;
  target?: React.RefObject<HTMLElement>;
}

export function useOffSetTop(top = 0, options?: UseScrollOptions): ReturnType {
  const { scrollY } = useScroll(options);

  const { value, onTrue: setOffSetTop, onFalse: clearOffSetTop } = useBoolean();

  const onOffSetTop = useCallback(() => {
    scrollY.on('change', (scrollHeight) => {
      if (scrollHeight > top) {
        setOffSetTop();
      } else {
        clearOffSetTop();
      }
    });
  }, [scrollY, top, setOffSetTop, clearOffSetTop]);

  useEffect(() => {
    onOffSetTop();
  }, [onOffSetTop]);

  const memoizedValue = useMemo(() => value, [value]);

  return memoizedValue;
}

// Usage
// const offset = useOffSetTop(100);

// Or
// const offset = useOffSetTop(100, {
//   container: ref,
// });
